import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  Router,
  RouterEvent,
  NavigationStart,
  NavigationEnd,
} from '@angular/router';
import { LoadingService } from './shared/services/loading.service';
import { delay } from 'rxjs/operators';
import { FilterHelperService } from './shared/services/filter-helper.service';
import { InspectionService } from './shared/services/http-client-service/inspection.service';
@Component({
  selector: 'adam-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'adam-ui';
  isLoader: boolean = false;
  downloadCount: any;
  totalDownloadCount: any;
  progressValue: number = 0;
  show: boolean = false;

  constructor(
    private _router: Router,
    private loadingService: LoadingService,
    private inspectionService: InspectionService
  ) {}

  ngOnInit() {
    this.routerEvents();
    this.listenToLoading();
    this.inspectionService.recieveTotalDownloadCount().subscribe((x) => {
      this.totalDownloadCount = x;
      this.progressValue = (this.downloadCount / x) * 100;
    });
    this.inspectionService.recieveDownloadCount().subscribe((x) => {
      this.downloadCount = x;
      if (this.totalDownloadCount == x) {
        this.inspectionService.setPolling(false);
      }
    });
    this.inspectionService
      .recieveTosterStatus()
      .subscribe((x) => (this.show = x));
  }

  listenToLoading(): void {
    this.loadingService.loadingSub
      .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe((result) => {
        this.isLoader = result;
      });
  }

  routerEvents() {
    this._router.events.subscribe((event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loadingService.loadingSub.next(true);
          break;
        }
        case event instanceof NavigationEnd: {
          this.loadingService.loadingSub.next(false);
          break;
        }
      }
    });
  }
}
